import template from './sw-cms-preview-form.html.twig';
import './sw-cms-preview-form.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
